<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="px-6 py-4 guard-configuration">
  <div class="flex justify-content-between mb-4">
    <p class="text-xl font-semibold">
      {{ 'layout.configurations.guardConfiguration.title' | translate }}
    </p>
    <p-button
      *emPermission="Permission.CONFIG_INVOICING"
      class="p-button-success"
      icon="pi pi-plus"
      severity="success"
      (onClick)="onAdd()">
    </p-button>
  </div>

  <p-table
    [value]="guardConfigurations"
    [loading]="isLoading"
    [paginator]="true"
    [rows]="10"
    responsiveLayout="scroll"
    styleClass="w-full p-datatable-sm guard-table">
    <ng-template pTemplate="header">
      <tr>
        <th class="bg-white">
          {{ 'layout.configurations.guardConfiguration.table.label' | translate }}
        </th>
        <th class="bg-white">
          {{ 'layout.configurations.guardConfiguration.table.currency' | translate }}
        </th>
        <th class="bg-white">
          {{ 'layout.configurations.guardConfiguration.table.startDate' | translate }}
        </th>
        <th class="bg-white">
          {{ 'layout.configurations.guardConfiguration.table.endDate' | translate }}
        </th>
        <th class="bg-white">
          {{ 'layout.configurations.guardConfiguration.table.laborable' | translate }}
        </th>
        <th class="bg-white">
          {{ 'layout.configurations.guardConfiguration.table.noLaborable' | translate }}
        </th>
        <th class="bg-white">
          {{ 'layout.configurations.guardConfiguration.table.especial' | translate }}
        </th>
        <th class="bg-white">
          {{ 'layout.configurations.guardConfiguration.table.status' | translate }}
        </th>
        <th *emPermission="Permission.CONFIG_INVOICING" class="bg-white text-center">
          {{ 'layout.configurations.guardConfiguration.table.actions' | translate }}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-guardConfiguration>
      <tr>
        <td class="combined-label">{{ getRateLabel(guardConfiguration) }}</td>
        <td class="combined-label">{{ guardConfiguration.currencyName }}</td>
        <td>{{ guardConfiguration.startDate | date: 'yyyy-MM-dd' }}</td>
        <td>{{ guardConfiguration.endDate | date: 'yyyy-MM-dd' }}</td>
        <td>{{ guardConfiguration.laborable }}</td>
        <td>{{ guardConfiguration.nonLaborable }}</td>
        <td>{{ guardConfiguration.especial }}</td>
        <td>
          <p-tag
            [value]="getStatusLabel(guardConfiguration.status)"
            [severity]="getStatusSeverity(guardConfiguration.status)">
          </p-tag>
        </td>
        <td *emPermission="Permission.CONFIG_INVOICING" class="text-center">
          <p-button
            icon="pi pi-pencil"
            [outlined]="true"
            class="mr-2"
            severity="info"
            (onClick)="onEdit(guardConfiguration)"
            [pTooltip]="'layout.configurations.guardConfiguration.actions.edit' | translate">
          </p-button>
          <p-button
            icon="pi pi-trash"
            [outlined]="true"
            severity="danger"
            (onClick)="onDelete($event, guardConfiguration)"
            [pTooltip]="'layout.configurations.guardConfiguration.actions.delete' | translate">
          </p-button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="9" class="text-center">
          {{ 'layout.configurations.guardConfiguration.empty' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
